import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import {
  ADMIN_KEY,
  URL as CLIENT_URL,
  AFFILIATE_APP_URL,
} from "../../config/config";
import {
  Theme,
  createStyles,
  withStyles,
  WithStyles,
  DialogTitle,
  DialogContent,
  Grid,
  Typography,
  Button,
  Collapse,
  Box,
  Snackbar,
  Link,
  Tooltip,
  TextField,
  Divider,
  Drawer,
  FormControlLabel,
  Checkbox,
  Switch,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Dialog,
  DialogContentText,
  DialogActions,
  TablePagination,
} from "@material-ui/core";
import { Autocomplete, Alert } from "@material-ui/lab";
import { Edit } from "@material-ui/icons";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackOutlined from "@material-ui/icons/ArrowBackOutlined";
import { formatCurrency } from "../../helpers/currency";
import { createRandomString } from "../../helpers/hashing";
import { Sync } from "@material-ui/icons";
import { DateRangePicker } from "react-dates";
import moment from "moment-timezone";
import ReactJson from "react-json-view";
import CircularProgress from "@material-ui/core/CircularProgress";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { th } from "date-fns/locale";

const Tier_Limit = [
  { name: "Tier 0 : Regular (20%)", value: "tier0" },
  { name: "Tier 1 : Growth (25%)", value: "tier1" },
  { name: "Tier 2 : Integration (30%)", value: "tier2" },
];

const getTierName = (value) => {
  return Tier_Limit.find((t) => t.value === value)?.name || value;
};

const AFFILIATE_STATUSES = [
  "ACTIVE",
  "INACTIVE",
  "CHURNED",
  "TERMINATED",
  "BUSINESS_CLOSED",
  "INTERNAL_TESTING",
  "EXPLORATORY",
  "MIGRATED_FROM_TAPAFFILIATE",
];

class AffiliateDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props.partner,
      alert: false,
      alertMsg: "",
      alertSeverity: "",
      showCode: false,
      isDrawerOpen: false,
      logs: [],
      currencyFilter: "INR",
      showDialog: false,
      commissionAmount: 0,
      balanceOnHold: 0,
      totalCommisionPaid: 0,
      newPassword: "",
      loading: false,
      remarks: "",
      applied: {
        createdAt: {
          startDate: null,
          endDate: null,
          focusedInput: null,
        },
      },
      affiliateNameDialog: false,
      changeAffiliateName: "",
      tierLimit: "",
      selectedAffiliateStatus: props.partner?.status || "",
      partnershipStatusRemark: props.partner?.partnershipStatusRemark || "",
      aiCallingExcluded: !!props.partner?.aiCallingExcluded,
      assignedKAM: "",
      tierHistory: props.partner?.upgrade_affiliate_plan_chain || [],
      kamHistory: props.partner?.kam_update_chain || [],
      amountToBeCleared: 0,
      bankAccountNumber: "",
      utrNumber: "",
      paymentDate: "",

      // Paid dues history state
      paidDues: [],
      paidDuesSkip: 0,
      paidDuesTotal: 0,
      paidDuesRowsPerPage: 15,
      paidDuesLoading: false,
      paidDuesHasMore: true,
      paidDuesPage: 0,
      tdsAmount: 0,
      KAM: [], // Initialize as empty array instead of undefined
    };
  }

  onClose = this.props.onClose;

  componentDidMount() {
    const { actions } = this.props;

    if (actions.includes("viewLogs")) {
      axios
        .post(`${CLIENT_URL}/superadmin/affiliate-super-admin-logs`, {
          affiliateId: this.props.partner._id,
        })
        .then((response) => {
          const newLogs = response.data
            .map((log) => {
              const newLog = { ...log };
              delete newLog.body.affiliateId;
              return Object.keys(newLog.body).length > 0 ? newLog : null;
            })
            .filter((log) => log !== null);

          this.setState({ logs: newLogs });
        })
        .catch((error) => {
          console.error(error);
        });
    }

    // Keep this outside the axios chain so it's always called
    this.fetchAllAgents();
    // Initial fetch for paid dues history
    this.fetchAllPaidDuesHistory(true);
  }

  setAffiliateInDB = async (fields) => {
    try {
      const { partner } = this.props;
      const { _id } = partner;
      const queryObj = {
        affiliateId: _id,
        fields,
      };
      const response = await axios.post(
        CLIENT_URL + "/superadmin/set-affiliate-field",
        {
          ...queryObj,
        }
      );
      return response;
    } catch (error) {
      console.log(error);
      this.showErrorMessage("Unable to update field in DB");
      throw error;
    }
  };

  fetchAllAgents = () => {
    axios
      .get(CLIENT_URL + "/superadmin/get-agents")
      .then((res) => {
        this.setState({ KAM: res.data || [] }); // Ensure it's always an array
      })
      .catch((err) => {
        console.log(err);
        this.setState({ KAM: [] }); // Set empty array on error
      });
  };

  updateAffiliateName = async () => {
    const affiliate = this.props.partner;
    await this.setAffiliateInDB({
      name: this.state.changeAffiliateName,
    })
      .then((response) => {
        affiliate.name = this.state.changeAffiliateName;
        // this.props.setPartner(affiliate);
        this.closeConfirmNameDialog();
        this.setState({
          changeAffiliateName: "",
        });
      })
      .catch((error) => {
        this.closeConfirmNameDialog();
        this.setState({
          changeAffiliateName: "",
        });
      });
  };

  getTierLimit = () => {
    const result = Tier_Limit.filter((e) => e.name === this.state.tierLimit);
    return result[0].value;
  };

  updateAffiliateTierLimit = async () => {
    const limit = this.getTierLimit();
    const { partner } = this.props;

    try {
      await this.setAffiliateInDB({
        affiliatePlan: limit,
      });

      const filter = { search: partner._id };
      const response = await axios.get(
        `${CLIENT_URL}/superadmin/get-affiliates`,
        {
          params: {
            allFilters: JSON.stringify(filter),
          },
        }
      );

      if (response?.data?.affiliates?.length) {
        const updatedAffiliate = response.data.affiliates[0];

        // 3. Update state with new partner info + history
        this.setState({
          tierLimit: this.getTierLimit(updatedAffiliate.affiliatePlan),
          tierHistory: updatedAffiliate.upgrade_affiliate_plan_chain || [],
        });
      }

      this.showSuccessMessage("Tier updated successfully!");
    } catch (error) {
      console.error("Update affiliate tier error:", error);
      this.showErrorMessage("Unable to update Tier Limit");
    }
  };

  updateAffiliateKAM = async () => {
    const assignedKAM = this.state.selectedKAM?.email;
    const { partner } = this.props;

    try {
      await this.setAffiliateInDB({
        kamAssigned: assignedKAM,
      });

      const filter = { search: partner._id };
      const response = await axios.get(
        `${CLIENT_URL}/superadmin/get-affiliates`,
        {
          params: {
            allFilters: JSON.stringify(filter),
          },
        }
      );

      if (response?.data?.affiliates?.length) {
        const updatedAffiliate = response.data.affiliates[0];

        // 3. Update state with new partner info + history
        this.setState({
          currentKam: updatedAffiliate.currentKam || "",
          kamHistory: updatedAffiliate.kam_update_chain || [],
        });
      }

      this.showSuccessMessage("KAM Assigned successfully!");
    } catch (error) {
      console.error("Update affiliate tier error:", error);
      this.showErrorMessage("Unable to update KAM");
    }
  };

  handleDrawerOpen = async () => {
    this.setState({ isDrawerOpen: true });
  };
  handleDrawerClose = () => {
    this.setState({ isDrawerOpen: false });
  };

  showSuccessMessage = (message) =>
    this.setState({
      alert: true,
      alertMsg: message,
      alertSeverity: "success",
    });

  showErrorMessage = (message) =>
    this.setState({
      alert: true,
      alertMsg: message,
      alertSeverity: "error",
    });

  closeSnackbar = () => {
    this.setState({ alert: false, alertMsg: "", alertSeverity: "" });
  };

  getFormattedDate = (date) => {
    if (date) {
      const formattedDate = moment
        .tz(new Date(date), "Asia/Calcutta")
        .endOf("day")
        .format("DD MMMM YYYY");
      return formattedDate;
    }
  };

  clearDues = async () => {
    if (this.state.clearingDues) return;
    try {
      this.setState({ clearingDues: true });
      const {
        currencyFilter,
        remarks,
        utrNumber,
        amountToBeCleared,
        bankAccountNumber,
        paymentDate,
        tdsAmount,
      } = this.state;

      const { partner } = this.props;
      const { _id } = partner;

      if (
        !utrNumber ||
        !amountToBeCleared ||
        !bankAccountNumber ||
        !paymentDate ||
        !remarks
      ) {
        this.showErrorMessage("Please fill all the fields");
        this.setState({ clearingDues: false });
        return;
      }

      const response = await axios.post(
        `${CLIENT_URL}/superadmin/update-affiliate-dues`,
        {
          affiliateId: _id,
          currency: currencyFilter,
          utrNumber: utrNumber,
          bankAccountNumber: bankAccountNumber,
          remarks: remarks,
          amountPaid: amountToBeCleared * Math.pow(10, 5),
          paymentDate: paymentDate,
          tdsAmount: tdsAmount * Math.pow(10, 5) || 0,
        }
      );

      this.showSuccessMessage("Dues Cleared Successfully");
      this.setState({ clearingDues: false, showDialog: false, remarks: "" });
      // Refresh paid dues history after successful clear
      this.fetchAllPaidDuesHistory(true);
    } catch (error) {
      this.setState({ clearingDues: false, showDialog: false, remarks: "" });
      this.showErrorMessage("Unable to clear dues , Invalid Input");
    }
  };

  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  fetchAllPaidDuesHistory = async (reset = false) => {
    try {
      const { partner } = this.props;
      const { _id } = partner;

      const skip = reset ? 0 : this.state.paidDuesSkip;
      const rowsPerPage = this.state.paidDuesRowsPerPage;

      this.setState({ paidDuesLoading: true });

      const { data } = await axios.get(
        `${CLIENT_URL}/superadmin/get-paid-dues-history`,
        {
          params: {
            affiliateId: _id,
            skip,
            rowsPerPage,
          },
        }
      );

      const newItems = Array.isArray(data?.affiliates) ? data.affiliates : [];
      const newSkip = skip + newItems.length;

      const paidDues = reset ? newItems : [...this.state.paidDues, ...newItems];
      const hasMore = newItems.length === rowsPerPage;

      this.setState({
        paidDues,
        paidDuesSkip: newSkip,
        paidDuesHasMore: hasMore,
        paidDuesLoading: false,
        paidDuesPage: reset ? 0 : this.state.paidDuesPage,
      });
    } catch (error) {
      console.error(error);
      this.setState({ paidDuesLoading: false });
      this.showErrorMessage("Unable to fetch paid dues history");
    }
  };

  handlePaidDuesPageChange = async (_, newPage) => {
    try {
      const visibleRowsPerPage = 5;
      const needed = (newPage + 1) * visibleRowsPerPage;
      if (
        needed > this.state.paidDues.length &&
        this.state.paidDuesHasMore &&
        !this.state.paidDuesLoading
      ) {
        await this.fetchAllPaidDuesHistory(false);
      }
      this.setState({ paidDuesPage: newPage });
    } catch (e) {
      console.error(e);
    }
  };

  fetchAggregatedBilling = async () => {
    try {
      this.setState({ loading: true });
      const { currencyFilter } = this.state;

      const { partner } = this.props;
      const { _id } = partner;
      const response = await axios.post(
        `${CLIENT_URL}/superadmin/aggregate-affiliate-billings`,
        {
          affiliateId: _id,
          currency: currencyFilter,
        }
      );

      const totalCommision = response?.data?.totalCommission || 0;
      const balanceOnHoldValue = response?.data?.balanceOnHold || 0;

      const formattedCommision =
        (totalCommision / Math.pow(10, 5)).toFixed(2) || 0;
      const formattedHoldBalance =
        (balanceOnHoldValue / Math.pow(10, 5)).toFixed(2) || 0;

      const totalCommisionPaid = formattedCommision - formattedHoldBalance;

      this.setState({
        commissionAmount: formattedCommision,
        balanceOnHold: formattedHoldBalance,
        totalCommisionPaid: totalCommisionPaid.toFixed(2),
        showDialog: true,
      });
      this.setState({ loading: false });
      this.showSuccessMessage("Amount Aggregated Successfully");
    } catch (error) {
      this.setState({ loading: false });
      this.showErrorMessage("Unable to aggregate amount");
    }
  };

  setCurrencyFilter = (event) => {
    this.setState({ currencyFilter: event.target.value });
  };

  clearDate = () => {
    const filterKey = "createdAt";
    const applied = { ...this.state.applied };
    applied[filterKey].startDate = null;
    applied[filterKey].endDate = null;
    this.setState({ applied });
  };
  checkDateInput = (filterKey) => {
    const applied = { ...this.state.applied };
    const s = applied[filterKey];
    if (s.startDate && s.endDate) {
      return;
    } else {
      this.clearDate(filterKey);
    }
  };

  setFocus = (filterKey, focusedInput) => {
    const applied = { ...this.state.applied };
    applied[filterKey].focusedInput = focusedInput;
    this.setState({ applied });
  };

  setDate = (filterKey, startDate, endDate) => {
    const applied = { ...this.state.applied };
    applied[filterKey].startDate = startDate;
    applied[filterKey].endDate = endDate;
    this.setState({ applied });
  };

  loginAsOwner = async () => {
    const { partner } = this.props;
    const { _id } = partner;

    try {
      const {
        data: { token },
      } = await axios.post(
        `${CLIENT_URL}/superadmin/generate-any-token`,
        {
          _id,
          type: "affiliate",
        },
        {
          headers: {
            "x-aisensy-admin-token-key": ADMIN_KEY,
          },
        }
      );
      window.open(`${AFFILIATE_APP_URL}/login?token=${token}`, "_blank");
    } catch (error) {}
  };

  resetPassword = async () => {
    try {
      const loginPassword = createRandomString();
      await axios.patch(`${CLIENT_URL}/superadmin/reset-affiliate-password`, {
        affiliateId: this.props.partner._id,
        loginPassword,
      });

      this.showSuccessMessage("Password Reset Successful!");
      return loginPassword;
    } catch (error) {
      this.showErrorMessage("Unable to reset password");
    }
  };

  handleResetPassword = async () => {
    const newPass = await this.resetPassword();
    newPass && this.setState({ newPassword: newPass });
  };

  copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
  };

  openaffiliateNameDialog = () => {
    this.setState({ affiliateNameDialog: true });
  };

  closeaffiliateNameDialog = () => {
    this.setState({ affiliateNameDialog: false });
  };

  openConfirmNameDialog = () => {
    this.setState({ nameConfirmationDialog: true });
  };

  closeConfirmNameDialog = () => {
    this.setState({ nameConfirmationDialog: false });
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  updateAffiliateStatus = async () => {
    const affiliate = this.props.partner;
    try {
      await this.setAffiliateInDB({
        status: this.state.selectedAffiliateStatus,
        partnershipStatusRemark: this.state.partnershipStatusRemark,
      });
      affiliate.status = this.state.selectedAffiliateStatus;
      affiliate.partnershipStatusRemark = this.state.partnershipStatusRemark;
      this.showSuccessMessage("Affiliate status updated successfully");
    } catch (error) {
      this.showErrorMessage("Unable to update affiliate status");
    }
  };

  toggleAiCallingExclusion = async (nextValue) => {
    const affiliate = this.props.partner;
    const previous = this.state.aiCallingExcluded;
    // Optimistic — reflect the switch immediately, revert if the write fails.
    this.setState({ aiCallingExcluded: nextValue });
    try {
      await this.setAffiliateInDB({ aiCallingExcluded: nextValue });
      affiliate.aiCallingExcluded = nextValue;
      this.showSuccessMessage(
        nextValue
          ? "Affiliate excluded from AI calling"
          : "Affiliate included in AI calling"
      );
    } catch (error) {
      this.setState({ aiCallingExcluded: previous });
    }
  };

  render() {
    const { classes, partner, agent, actions } = this.props;
    const t = this.state;

    const viewLogsPermission = actions.includes("viewLogs");
    const loginPermission = actions.includes("login");

    return (
      <>
        <DialogTitle className={classes.title}>
          <Grid container alignItems="center" spacing={2}>
            <Grid item>
              <IconButton
                size="small"
                aria-label="close"
                onClick={this.onClose}
              >
                <ArrowBackOutlined />
              </IconButton>
            </Grid>
            <Grid item>
              <Grid container alignItems="center">
                <Grid item style={{ flexGrow: 1, display: "flex" }}>
                  <Typography variant="h3" component="p">
                    {partner.name || partner.brandName}
                  </Typography>
                  <IconButton
                    onClick={() => {
                      this.openaffiliateNameDialog();
                    }}
                    disabled={!this.props.hasWriteAccess}
                    style={{ paddingTop: "3px" }}
                  >
                    <Edit fontSize="small" />
                  </IconButton>
                </Grid>
              </Grid>
            </Grid>

            <div>
              <Dialog
                open={this.state.affiliateNameDialog}
                onClose={this.closeaffiliateNameDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                  style: { height: "20%", width: "35%" },
                }}
              >
                <DialogContent>
                  <DialogContentText>
                    Enter new affiliate name:
                  </DialogContentText>
                  <TextField
                    name="changeAffiliateName"
                    value={this.state.changeAffiliateName}
                    onChange={this.handleChange}
                    disabled={!this.props.hasWriteAccess}
                    style={{
                      width: "80%",
                      border: "1px solid ",
                      background: "white",
                    }}
                  />
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={this.closeaffiliateNameDialog}
                    color="primary"
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={() => {
                      this.closeaffiliateNameDialog();
                      this.openConfirmNameDialog();
                    }}
                    color="primary"
                    disabled={!this.state.changeAffiliateName}
                  >
                    Confirm
                  </Button>
                </DialogActions>
              </Dialog>
            </div>
            <div>
              <Dialog
                open={this.state.nameConfirmationDialog}
                onClose={this.closeConfirmNameDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{
                  style: { height: "18%", width: "35%" },
                }}
              >
                <DialogContent>
                  <Typography
                    variant="body1"
                    style={{
                      fontFamily: "Roboto, sans-serif",
                      fontSize: "16px",
                    }}
                  >
                    Are you sure you want to change affiliate name from <br />
                    <b>{partner.name}</b> to{" "}
                    <b>{this.state.changeAffiliateName}</b>?
                  </Typography>
                </DialogContent>
                <DialogActions>
                  <Button onClick={this.closeConfirmNameDialog} color="primary">
                    Cancel
                  </Button>
                  <Button
                    onClick={() => {
                      this.updateAffiliateName();
                      this.closeConfirmNameDialog();
                    }}
                    color="primary"
                  >
                    Yes
                  </Button>
                </DialogActions>
              </Dialog>
            </div>
            <Grid item xs />
            {loginPermission && (
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.loginAsOwner}
                >
                  Login
                </Button>
              </Grid>
            )}
            {viewLogsPermission && (
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.handleDrawerOpen}
                >
                  View Logs
                </Button>
              </Grid>
            )}
            <div>
              <Drawer
                anchor="right"
                open={this.state.isDrawerOpen}
                onClose={this.handleDrawerClose}
                className={classes.drawerWidth}
              >
                <Box style={{ padding: "16px" }}>
                  <Typography
                    variant="h5"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      height: "50px",
                      alignItems: "center",
                      marginBottom: "20px",
                      background: "#EBF5F3",
                    }}
                  >
                    Partner Admin Logs
                  </Typography>
                  {this.state.logs.length === 0
                    ? "No Logs found"
                    : this.state.logs.map((log, index) => {
                        const createdAtDate = new Date(log.createdAt);
                        const formattedDate = `${createdAtDate.toLocaleDateString()}`;
                        const formattedTime = `${createdAtDate.toLocaleTimeString()}`;
                        return (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "flex-end",
                              borderBottom: "1px solid #ccc",
                              paddingBottom: "10px",
                              marginBottom: "15px",
                            }}
                          >
                            <div>
                              <div
                                style={{
                                  marginBottom: "10px",
                                  fontSize: "12px",
                                }}
                              >
                                <ReactJson
                                  src={log.body}
                                  displayDataTypes={false}
                                  displayObjectSize={false}
                                  enableClipboard={false}
                                  name="Changes"
                                  shouldCollapse={(field) => {
                                    if (
                                      field?.name?.includes("marketing") ||
                                      field?.name?.includes("utility") ||
                                      field?.name?.includes("authentication") ||
                                      field?.name?.includes("service")
                                    ) {
                                      return true;
                                    }
                                    return false;
                                  }}
                                />
                              </div>
                              <Typography variant="body1">
                                Name: {log.displayName}
                              </Typography>
                              <Typography variant="body1">
                                Date: {formattedDate}
                              </Typography>
                              <Typography variant="body1">
                                Time: {formattedTime}
                              </Typography>
                            </div>
                            {log?.body?.amount && (
                              <Typography
                                variant="body1"
                                style={{
                                  width: "43%",
                                  color: "#0a474c",
                                  fontWeight: "bold",
                                }}
                              >
                                Template Credit: {`${partner.currency} `}
                                {log?.body?.action === "ADD" ? "(+)" : "(-)"}
                                {log?.body?.amount / Math.pow(10, 5)}
                              </Typography>
                            )}
                          </div>
                        );
                      })}
                </Box>
              </Drawer>
            </div>
          </Grid>
        </DialogTitle>
        <fieldset
          disabled={!this.props.hasWriteAccess}
          style={{
            border: "none",
            padding: 0,
            margin: 0,
          }}
        >
          <DialogContent className={classes.content}>
            <Box
              px={{
                xs: 2,
                md: 30,
              }}
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Box py={2} px={2} my={2} className={classes.container}>
                <Box>
                  <Typography
                    variant="body1"
                    gutterBottom
                    className={classes.sectionTitle}
                  >
                    Commission Payout Details
                  </Typography>
                </Box>
                <Box my={2}>
                  <Grid
                    container
                    // xs={12}
                    style={{
                      display:
                        window.innerWidth <= 850 ? "inline-block" : "flex",
                      alignItems: "center",
                    }}
                  >
                    <Grid item xs={6} style={{ marginLeft: "20px" }}>
                      <FormControl component="fieldset">
                        <RadioGroup
                          row
                          value={this.state.currencyFilter}
                          onChange={this.setCurrencyFilter}
                        >
                          <FormControlLabel
                            value="INR"
                            control={<Radio color="primary" />}
                            label="INR"
                            labelPlacement="end"
                          />
                          <FormControlLabel
                            value="USD"
                            control={<Radio color="primary" />}
                            label="USD"
                            labelPlacement="end"
                          />
                        </RadioGroup>
                      </FormControl>

                      <Box
                        mt={2}
                        display="flex"
                        justifyContent={{
                          xs: "flex-start",
                          sm: "flex-start",
                        }}
                      >
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={this.fetchAggregatedBilling}
                          disabled={this.state.loading}
                          startIcon={
                            this.state.loading ? (
                              <CircularProgress size={20} />
                            ) : null
                          }
                        >
                          {!this.state.loading && "Fetch Aggregated Dues"}
                        </Button>
                      </Box>
                    </Grid>

                    <Box mt={3} style={{ maxWidth: 800, minWidth: 800 }}>
                      <Typography
                        variant="body1"
                        gutterBottom
                        className={classes.sectionTitle}
                      >
                        Payment Clearance History
                      </Typography>

                      <TableContainer
                        component={Paper}
                        className={classes.tableContainer}
                        style={{ maxWidth: 800, minWidth: 800 }}
                      >
                        <Table
                          size="small"
                          style={{ tableLayout: "fixed", width: "100%" }}
                        >
                          <colgroup>
                            <colgroup>
                              <col style={{ width: "15%" }} /> {/* Amount */}
                              <col style={{ width: "10%" }} />{" "}
                              {/* TDS Amount */}
                              <col /> {/* Bank Account Number (auto) */}
                              <col /> {/* UTR Number (auto) */}
                              <col style={{ width: "20%" }} />{" "}
                              {/* Payment Date */}
                              <col style={{ width: "25%" }} /> {/* Remarks */}
                            </colgroup>
                          </colgroup>
                          <TableHead>
                            <TableRow>
                              <TableCell
                                className={classes.tableHeadCell}
                                align="right"
                              >
                                Amount
                              </TableCell>
                              <TableCell className={classes.tableHeadCell}>
                                TDS Amount
                              </TableCell>
                              <TableCell className={classes.tableHeadCell}>
                                Bank Account Number
                              </TableCell>
                              <TableCell className={classes.tableHeadCell}>
                                UTR Number
                              </TableCell>
                              <TableCell className={classes.tableHeadCell}>
                                Payment Date
                              </TableCell>
                              <TableCell className={classes.tableHeadCell}>
                                Remark
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {this.state.paidDues
                              .slice(
                                this.state.paidDuesPage * 5,
                                this.state.paidDuesPage * 5 + 5
                              )
                              .map((row, index) => {
                                const amount =
                                  (row.amountPaid || 0) / Math.pow(10, 5);
                                const tdsAmount =
                                  (row.tdsAmount || 0) / Math.pow(10, 5);
                                const displayDate = row.paymentDate
                                  ? new Date(row.paymentDate).toLocaleString()
                                  : "";
                                return (
                                  <TableRow key={`${row._id || index}`}>
                                    <TableCell
                                      align="right"
                                      className={classes.tableCellNowrap}
                                    >
                                      {`${
                                        row.currency ||
                                        this.state.currencyFilter ||
                                        ""
                                      } ${amount.toFixed(2)}`}
                                    </TableCell>
                                    <TableCell
                                      className={classes.tableCellNowrap}
                                    >
                                      {`${
                                        row.currency ||
                                        this.state.currencyFilter ||
                                        ""
                                      } ${tdsAmount.toFixed(2)}`}
                                    </TableCell>
                                    <TableCell
                                      className={classes.tableCellNowrap}
                                    >
                                      {row.bankAccountNumber || "-"}
                                    </TableCell>
                                    <TableCell
                                      className={classes.tableCellNowrap}
                                    >
                                      {row.utrNumber || "-"}
                                    </TableCell>
                                    <TableCell
                                      className={classes.tableCellNowrap}
                                    >
                                      <span className={classes.tableCell}>
                                        {displayDate}
                                      </span>
                                    </TableCell>
                                    <TableCell className={classes.tableCell}>
                                      {row.remarks || "-"}
                                    </TableCell>
                                  </TableRow>
                                );
                              })}
                            {this.state.paidDuesLoading && (
                              <TableRow>
                                <TableCell colSpan={6}>
                                  <Box
                                    display="flex"
                                    justifyContent="center"
                                    py={1}
                                  >
                                    <CircularProgress size={20} />
                                  </Box>
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>

                        <Box
                          display="flex"
                          justifyContent="center"
                          mt={1}
                          className={classes.pagination}
                        >
                          <TablePagination
                            component="div"
                            count={
                              this.state.paidDuesHasMore
                                ? this.state.paidDues.length + 1
                                : this.state.paidDues.length
                            }
                            page={this.state.paidDuesPage || 0}
                            onPageChange={this.handlePaidDuesPageChange}
                            rowsPerPage={5}
                            rowsPerPageOptions={[5]}
                          />
                        </Box>
                      </TableContainer>
                    </Box>
                  </Grid>
                </Box>
              </Box>
              <Box py={2} px={2} my={1} className={classes.container}>
                <Typography
                  variant="body1"
                  gutterBottom
                  style={{ fontWeight: "bold" }}
                >
                  Reset Password
                </Typography>
                <Typography variant="body2" gutterBottom>
                  User Name: {partner.userName}
                </Typography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={6}>
                    <TextField
                      className={classes.textFieldDisabled}
                      disabled={true}
                      type="text"
                      placeholder="Click Reset to get a new password"
                      fullWidth
                      value={this.state.newPassword}
                      InputProps={{
                        endAdornment: (
                          <span>
                            <Tooltip title="Click to copy Password">
                              <IconButton
                                size="small"
                                disabled={!this.state.newPassword}
                                onClick={() =>
                                  this.copyToClipboard(this.state.newPassword)
                                }
                              >
                                <FileCopyIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </span>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={this.handleResetPassword}
                    >
                      Reset
                    </Button>
                  </Grid>
                </Grid>
              </Box>

              <Box py={2} px={2} my={2} className={classes.container}>
                <Box>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Update Affiliate Tier Level
                  </Typography>
                  <Typography variant="body1" gutterBottom>
                    Current Tier -{" "}
                    {Tier_Limit.find(
                      (limit) => limit.value === partner.affiliatePlan
                    )?.name || null}
                  </Typography>
                  <Grid container>
                    <Grid item xs={5} alignItems="center">
                      <Autocomplete
                        value={this.state.tierLimit}
                        options={Tier_Limit.map((option) => option.name)}
                        onChange={(e, value, reason) =>
                          this.setState({
                            tierLimit: value,
                          })
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            style={{
                              border: "1px solid ",
                              background: "white",
                              marginRight: 10,
                            }}
                            InputProps={{ ...params.InputProps }}
                            placeholder="Select Tier"
                            name="Affiliate Tier Limit"
                          />
                        )}
                      />
                    </Grid>
                    <Grid item>
                      <Typography variant="body1" gutterBottom>
                        <Button
                          style={{ marginLeft: 10 }}
                          color="primary"
                          variant="contained"
                          onClick={this.updateAffiliateTierLimit}
                        >
                          Update Tier Level
                        </Button>
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>

                {/* New Table Section */}
                <Box mt={4}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Tier Update History
                  </Typography>

                  <TableContainer
                    component={Paper}
                    style={{ width: "100%", maxWidth: 800 }} // adjust %
                  >
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell style={{ width: "25%" }}>From</TableCell>
                          <TableCell style={{ width: "25%" }}>To</TableCell>
                          <TableCell style={{ width: "30%" }}>
                            Updated By
                          </TableCell>
                          <TableCell style={{ width: "30%" }}>
                            Updated On
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.tierHistory
                          .slice() // copy so we don’t mutate state
                          .sort(
                            (a, b) =>
                              new Date(b.updatedAt) - new Date(a.updatedAt)
                          ) // latest first
                          .map((row, index) => (
                            <TableRow key={index}>
                              <TableCell>
                                {getTierName(row.existingPlan)}
                              </TableCell>
                              <TableCell>
                                {getTierName(row.changedPlan)}
                              </TableCell>
                              <TableCell>{row.updatedBy}</TableCell>
                              <TableCell>
                                {row.updatedAt
                                  ? new Date(row.updatedAt).toLocaleString()
                                  : ""}
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>
              {/* AFFILIATE KAM */}
              <Box py={2} px={2} my={2} className={classes.container}>
                <Box>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    Assign KAM
                  </Typography>

                  <Typography variant="body1" gutterBottom>
                    Current KAM - {partner.currentKam || "N/A"}
                  </Typography>

                  <Grid container>
                    <Grid item xs={5} alignItems="center">
                      <Autocomplete
                        value={this.state.selectedKAM}
                        options={this.state.KAM || []}
                        getOptionLabel={(option) => option?.name || ""}
                        onChange={(e, value) =>
                          this.setState({ selectedKAM: value })
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            style={{
                              border: "1px solid ",
                              background: "white",
                              marginRight: 10,
                            }}
                            placeholder={
                              this.state.KAM?.length > 0
                                ? "Select KAM"
                                : "Loading KAMs..."
                            }
                            disabled={
                              !this.state.KAM || this.state.KAM.length === 0
                            }
                          />
                        )}
                        noOptionsText={
                          this.state.KAM?.length === 0
                            ? "No KAMs available"
                            : "Loading..."
                        }
                      />
                    </Grid>

                    <Grid item>
                      <Typography variant="body1" gutterBottom>
                        <Button
                          style={{ marginLeft: 10 }}
                          color="primary"
                          variant="contained"
                          onClick={this.updateAffiliateKAM}
                        >
                          Assign KAM
                        </Button>
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>

                <Box mt={4}>
                  <Typography
                    variant="body1"
                    gutterBottom
                    style={{ fontWeight: "bold" }}
                  >
                    KAM Assign History
                  </Typography>

                  <TableContainer
                    component={Paper}
                    style={{ width: "100%", maxWidth: 800 }}
                  >
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell style={{ width: "25%" }}>From</TableCell>
                          <TableCell style={{ width: "25%" }}>To</TableCell>
                          <TableCell style={{ width: "30%" }}>
                            Updated By
                          </TableCell>
                          <TableCell style={{ width: "30%" }}>
                            Updated On
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.kamHistory
                          .slice()
                          .sort(
                            (a, b) =>
                              new Date(b.updatedAt) - new Date(a.updatedAt)
                          )
                          .map((row, index) => (
                            <TableRow key={index}>
                              <TableCell>{row.from || "N/A"}</TableCell>
                              <TableCell>{row.to || "N/A"}</TableCell>
                              <TableCell>{row.updatedBy}</TableCell>
                              <TableCell>
                                {row.updatedAt
                                  ? new Date(row.updatedAt).toLocaleString()
                                  : ""}
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Box>

              {/* AFFILIATE STATUS */}

              <Box py={2} px={2} my={2} className={classes.container}>
                <Typography
                  variant="body1"
                  gutterBottom
                  style={{ fontWeight: "bold" }}
                >
                  Update Affiliate Status
                </Typography>
                <Typography variant="body1" gutterBottom>
                  Current Status - {partner.status || "N/A"}
                </Typography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={4}>
                    <Autocomplete
                      disableClearable
                      value={this.state.selectedAffiliateStatus}
                      options={AFFILIATE_STATUSES}
                      onChange={(e, value, reason) =>
                        this.setState({
                          selectedAffiliateStatus: value || "",
                        })
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          style={{
                            border: "1px solid ",
                            background: "white",
                          }}
                          InputProps={{ ...params.InputProps }}
                          placeholder="Select Status"
                          name="Affiliate Status"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={5}>
                    <TextField
                      name="partnershipStatusRemark"
                      value={this.state.partnershipStatusRemark}
                      onChange={this.handleChange}
                      placeholder="Enter Remark"
                      style={{
                        border: "1px solid",
                        background: "white",
                        borderRadius: "8px",
                        padding: "0px",
                      }}
                      variant="outlined"
                      size="small"
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} sm={3}>
                    <Typography variant="body1" gutterBottom component="div">
                      <Button
                        color="primary"
                        variant="contained"
                        onClick={this.updateAffiliateStatus}
                        disabled={
                          !this.state.selectedAffiliateStatus ||
                          !this.state.partnershipStatusRemark ||
                          this.state.partnershipStatusRemark?.trim() === ""
                        }
                      >
                        Update Status
                      </Button>
                    </Typography>
                  </Grid>
                </Grid>
              </Box>

              {/* AI CALLING */}

              <Box py={2} px={2} my={2} className={classes.container}>
                <Typography
                  variant="body1"
                  gutterBottom
                  style={{ fontWeight: "bold" }}
                >
                  AI Calling
                </Typography>
                <Typography variant="body1" gutterBottom>
                  When excluded, this affiliate's customers receive no automated
                  AI calls (e.g. the signup onboarding call).
                </Typography>
                <FormControlLabel
                  control={
                    <Switch
                      color="primary"
                      checked={this.state.aiCallingExcluded}
                      onChange={(e) =>
                        this.toggleAiCallingExclusion(e.target.checked)
                      }
                    />
                  }
                  label={
                    this.state.aiCallingExcluded
                      ? "Excluded from AI calling"
                      : "Included in AI calling"
                  }
                />
              </Box>

              {/* <Box mb={4} className={classes.container}>
              <Grid
                container
                spacing={8}
                style={{
                  padding: "20px 30px 25px 30px",
                }}
              >
                <Grid xs={12}>
                  <Grid
                    xs={8}
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                    }}
                  >
                    <Typography variant="h4" style={{ marginBottom: "11px" }}>
                      {"Download Report"}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid>
                  <Typography
                    variant="h5"
                    color="textSecondary"
                    style={{ marginBottom: "15px" }}
                  >
                    {"Download Affiliate Report"}
                  </Typography>
                </Grid>

                <Grid
                  xs={12}
                  style={{
                    display: window.innerWidth <= 850 ? "inline-block" : "flex",
                    alignItems: "center",
                  }}
                >
                  <DateFilter
                    filterKey="createdAt"
                    filterName="Created At"
                    classes={classes}
                    applied={this.state.applied}
                    setDate={this.setDate}
                    setFocus={this.setFocus}
                    checkDateInput={this.checkDateInput}
                    clearDate={this.clearDate}
                  />
                  <Button
                    color="primary"
                    variant="contained"
                    style={{
                      marginLeft: 8,
                      height: 30,
                    }}
                    onClick={() => {
                      this.getReport();
                    }}
                  >
                    Download
                  </Button>
                </Grid>
              </Grid>
            </Box> */}
              <Grid container justifyContent="center">
                <Grid item>
                  <Button
                    color="primary"
                    onClick={() =>
                      this.setState({
                        showCode: !t.showCode,
                      })
                    }
                  >
                    {t.showCode ? "Hide" : "Show"} Code
                  </Button>
                </Grid>
              </Grid>
              <Collapse in={t.showCode}>
                <pre contentEditable={true} className={classes.codeBox}>
                  {JSON.stringify(this.props.partner, null, 2)}
                </pre>
              </Collapse>
            </Box>
          </DialogContent>
        </fieldset>
        <Snackbar
          open={this.state.alert}
          autoHideDuration={4000}
          onClose={this.closeSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={this.closeSnackbar}
            severity={this.state.alertSeverity}
          >
            {this.state.alertMsg}
          </Alert>
        </Snackbar>
        <Dialog
          open={this.state.showDialog}
          onClose={() => this.setState({ showDialog: false })}
          maxWidth="lg"
          PaperProps={{
            style: {
              maxHeight: "60%",
              width: "70%",
            },
          }}
        >
          <DialogTitle>Commission Details</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Grid
                container
                spacing={2}
                style={{ marginBottom: "20px" }}
                justifyContent="space-evenly"
              >
                <Box>
                  Total Commission:
                  <Typography
                    variant="body1"
                    style={{
                      fontWeight: "bold",
                      fontSize: "1.2rem",
                      marginBottom: "20px",
                    }}
                  >
                    {this.state.currencyFilter} {this.state.commissionAmount}
                  </Typography>
                </Box>
                <Box>
                  Commission Paid:
                  <Typography
                    variant="body1"
                    style={{
                      fontWeight: "bold",
                      fontSize: "1.2rem",
                      marginBottom: "20px",
                    }}
                  >
                    {this.state.currencyFilter} {this.state.totalCommisionPaid}
                  </Typography>
                </Box>
                <Box>
                  Balance On Hold:
                  <Typography
                    variant="body1"
                    style={{
                      fontWeight: "bold",
                      fontSize: "1.2rem",
                      marginBottom: "20px",
                    }}
                  >
                    {this.state.currencyFilter} {this.state.balanceOnHold}
                  </Typography>
                </Box>
              </Grid>
              <Grid container spacing={2}>
                {/* Amount and Bank Account Number - on one line */}
                <Grid item xs={12} md={6}>
                  <Box display="flex" flexDirection="column">
                    Amount:
                    <TextField
                      style={{
                        width: "95%",
                        border: "1px solid",
                        background: "white",
                        marginRight: 10,
                      }}
                      name="amountToBeCleared"
                      onChange={this.handleInput}
                      value={this.state.amountToBeCleared}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box display="flex" flexDirection="column">
                    Bank Account Number:
                    <TextField
                      style={{
                        width: "95%",
                        border: "1px solid",
                        background: "white",
                        marginRight: 10,
                      }}
                      name="bankAccountNumber"
                      onChange={this.handleInput}
                      value={this.state.bankAccountNumber}
                    />
                  </Box>
                </Grid>

                {/* UTR Number and Payment Date - on one line */}
                <Grid item xs={12} md={6}>
                  <Box display="flex" flexDirection="column">
                    UTR Number:
                    <TextField
                      style={{
                        width: "95%",
                        border: "1px solid",
                        background: "white",
                        marginRight: 10,
                      }}
                      name="utrNumber"
                      onChange={this.handleInput}
                      value={this.state.utrNumber}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box display="flex" flexDirection="column">
                    Payment Date:
                    <TextField
                      type="date"
                      style={{
                        width: "95%",
                        border: "1px solid",
                        background: "white",
                        marginRight: 10,
                      }}
                      InputLabelProps={{ shrink: true }}
                      name="paymentDate"
                      onChange={this.handleInput}
                      value={this.state.paymentDate}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box display="flex" flexDirection="column">
                    TDS Amount (if any):
                    <TextField
                      style={{
                        width: "95%",
                        border: "1px solid",
                        background: "white",
                        marginRight: 10,
                      }}
                      name="tdsAmount"
                      onChange={this.handleInput}
                      value={this.state.tdsAmount}
                    />
                  </Box>
                </Grid>
                {/* Remarks - full width */}
                <Grid item xs={12} md={6}>
                  <Box display="flex" flexDirection="column">
                    Enter Remarks:
                    <TextField
                      multiline
                      style={{
                        width: "95%",
                        border: "1px solid",
                        background: "white",
                        marginRight: 10,
                      }}
                      name="remarks"
                      onChange={this.handleInput}
                      value={this.state.remarks}
                    />
                  </Box>
                </Grid>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ marginBottom: "5px", marginRight: "5px" }}>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => this.setState({ showDialog: false })}
            >
              Close
            </Button>
            <Button
              onClick={() => this.clearDues()}
              variant="contained"
              color="primary"
              disabled={
                this.state.clearingDues ||
                Number(this.state.amountToBeCleared) >
                  Number(this.state.balanceOnHold) ||
                (this.state.currencyFilter === "INR"
                  ? Number(this.state.balanceOnHold) < 1000
                  : Number(this.state.balanceOnHold) < 10) ||
                !this.props.hasWriteAccess
              }
            >
              {this.state.clearingDues ? "Clearing..." : "Clear Dues"}
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

function DateFilter({
  filterKey,
  applied,
  setFocus,
  setDate,
  checkDateInput,
  clearDate,
  ...props
}) {
  const { classes, filterName } = props;
  const A = applied[filterKey];
  return (
    <div className={classes.datePickerPosition}>
      <Grid item xs style={{ display: "flex", justifyContent: "flex-start" }}>
        <DateRangePicker
          startDatePlaceholderText="From"
          endDatePlaceholderText="To"
          onClose={() => checkDateInput(filterKey)}
          startDateId="startDate"
          endDateId="endDate"
          startDate={A.startDate}
          endDate={A.endDate}
          onDatesChange={({ startDate, endDate }) =>
            setDate(filterKey, startDate, endDate)
          }
          onFocusChange={(focusedInput) => setFocus(filterKey, focusedInput)}
          navPosition="navPositionTop"
          numberOfMonths={1}
          hideKeyboardShortcutsPanel
          customArrowIcon={true}
          screenReaderInputMessage={" "}
          small
          readOnly
          maxDate={moment(new Date())}
          minimumNights={0}
          isOutsideRange={(day) =>
            day.isAfter(moment()) || moment().subtract(1, "days").isBefore(day)
          }
          focusedInput={A.focusedInput}
        />
      </Grid>
    </div>
  );
}

const styles = (theme) =>
  createStyles({
    root: {},
    logo: {
      height: theme.spacing(4),
    },
    drawerWidth: {
      "& .MuiDrawer-paper": {
        width: "32%",
      },
    },
    codeBox: {
      backgroundColor: "#eee",
      padding: "1rem",
      borderRadius: "12px",
      overflow: "auto",
      whiteSpace: "pre-wrap",
      wordWrap: "break-word",
    },
    container: {
      background: "#ebf5f3",
      padding: "30px",
      borderRadius: "8px",
    },
    sectionTitle: {
      fontWeight: "bold",
    },
    tableContainer: {
      width: "100%",
      maxWidth: 800,
    },
    tableHeadCell: {
      whiteSpace: "nowrap",
      fontWeight: 600,
    },
    tableCellNowrap: {
      whiteSpace: "nowrap",
    },
    tableCell: {
      whiteSpace: "normal",
      wordBreak: "break-word",
      overflowWrap: "anywhere",
    },

    pagination: {
      "& .MuiTablePagination-toolbar": {
        paddingLeft: 0,
      },
    },
    content: {
      backgroundColor: "#FDFFFC",
    },
    rotateIcon: {
      animation: "$spin 2s linear infinite",
    },
    "@keyframes spin": {
      "0%": {
        transform: "rotate(360deg)",
      },
      "100%": {
        transform: "rotate(0deg)",
      },
    },
    iconButton: {
      cursor: "pointer",
    },
    textField: {
      width: 200,
    },
    textFieldDisabled: {
      backgroundColor: "white",
    },
  });

const connectedPartnerDetails = connect((state) => ({
  agent: state.login.user,
  Permissions: state.login.permissions,
}))(AffiliateDetails);
export default withStyles(styles)(connectedPartnerDetails);
